"use client";

import { IBrandViewV2Response } from "@faire/web-api/indigofair/data/IBrandViewV2Response";
import React, { ReactNode, useContext } from "react";

import { useFetchCachedBrandView } from "../hooks/useFetchCachedBrandView";

interface IBrandPageBrandViewContext {
  brandViewLegacy?: IBrandViewV2Response | undefined;
  brandViewPromise?: Promise<IBrandViewV2Response | undefined>;
}

const DEFAULT_BRAND_PAGE_BRAND_VIEW_STATE: IBrandPageBrandViewContext = {
  brandViewLegacy: IBrandViewV2Response.build({}),
  brandViewPromise: Promise.resolve(undefined),
};

export const BrandPageBrandViewContext =
  React.createContext<IBrandPageBrandViewContext>(
    DEFAULT_BRAND_PAGE_BRAND_VIEW_STATE
  );

export const useBrandPageBrandViewContext = () => {
  const value = useContext(BrandPageBrandViewContext);

  if (value === DEFAULT_BRAND_PAGE_BRAND_VIEW_STATE) {
    throw new Error(
      "useBrandPageBrandViewContext must be used within a BrandPageBrandViewContext.Provider"
    );
  }
  return value;
};

export const BrandPageBrandViewClientContextProvider: React.FC<{
  brandToken: string;
  children: ReactNode;
}> = ({ brandToken, children }) => {
  const { data: brandViewData } = useFetchCachedBrandView(brandToken);

  return (
    <BrandPageBrandViewContext.Provider
      value={{
        brandViewLegacy: brandViewData,
      }}
    >
      {children}
    </BrandPageBrandViewContext.Provider>
  );
};
